import { Component, OnInit, PLATFORM_ID, inject } from '@angular/core';
import { ImageModel } from '../../model/image.model';
import { HeroSectionComponent } from '../../shared/components/hero-section/hero-section.component';
import { DarkModeService } from '../../shared/services/darkmode.service';
import { ChooseZeroComponent } from '../../shared/components/choose-zero/choose-zero.component';
import { HowAyrWorksCitizensComponent } from '../../shared/components/how-ayr-works-citizens/how-ayr-works-citizens.component';
import { AvoidedEmissionsComponent } from '../../shared/components/avoided-emissions/avoided-emissions.component';
import { SustainabilityPlatformComponent } from '../../shared/components/sustainability-platform/sustainability-platform.component';
import { ConsciousMobilityComponent } from '../../shared/components/conscious-mobility/conscious-mobility.component';
import { SustainableChoicesComponent } from '../../shared/components/sustainable-choices/sustainable-choices.component';
import { Title } from '@angular/platform-browser';
import { CarouselModule, OwlOptions } from 'ngx-owl-carousel-o';
import { TranslateModule } from '@ngx-translate/core';
@Component({
  selector: 'app-citizens',
  imports: [
    TranslateModule,
    HeroSectionComponent,
    ChooseZeroComponent,
    HowAyrWorksCitizensComponent,
    AvoidedEmissionsComponent,
    SustainabilityPlatformComponent,
    ConsciousMobilityComponent,
    SustainableChoicesComponent,
    CarouselModule,
  ],
  templateUrl: './citizens.component.html',
  styleUrl: './citizens.component.scss',
})
export class CitizensComponent implements OnInit {
  isDarkMode!: boolean;
  list: ImageModel[] = [];
  customOptions: OwlOptions = {
    // When carousel not needed, set false to mouseDrag, pullDrag, dots and nav
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    margin: 0,
    stagePadding: 0,
    navSpeed: 700,
    items: 1,
    nav: false,
    responsive: {
      0: {
        items: 1,
      },
    },
  };
  constructor(
    private darkModeService: DarkModeService,
    private titleService: Title,
  ) {}
  ngOnInit(): void {
    this.titleService.setTitle('AYR | Citizens');
    this.list = this.imagesBuilder();
    this.darkModeService.isDarkMode.subscribe((enabled) => {
      this.isDarkMode = enabled;
    });
  }

  imagesBuilder() {
    let home: ImageModel = {
      previewImageSrc:
        'https://storage.googleapis.com/weayr-assets-non-prod/images/citizens/Citizen_02_Overview.webp',
      thumbnailImageSrc:
        'https://storage.googleapis.com/weayr-assets-non-prod/images/citizens/Citizen_02_Overview.webp',
      alt: '',
      title: 'home',
    };

    let account: ImageModel = {
      previewImageSrc:
        'https://storage.googleapis.com/weayr-assets-non-prod/images/citizens/Citizen_05_AccountExpanded.webp',
      thumbnailImageSrc:
        'https://storage.googleapis.com/weayr-assets-non-prod/images/citizens/Citizen_05_AccountExpanded.webp',
      alt: '',
      title: 'account',
    };

    let climate: ImageModel = {
      previewImageSrc:
        'https://storage.googleapis.com/weayr-assets-non-prod/images/citizens/Citizen_07_ProfileResources.webp',
      thumbnailImageSrc:
        'https://storage.googleapis.com/weayr-assets-non-prod/images/citizens/Citizen_07_ProfileResources.webp',
      alt: '',
      title: 'profile',
    };

    let resources: ImageModel = {
      previewImageSrc:
        'https://storage.googleapis.com/weayr-assets-non-prod/images/citizens/Citizen_06_Resources.webp',
      thumbnailImageSrc:
        'https://storage.googleapis.com/weayr-assets-non-prod/images/citizens/Citizen_06_Resources.webp',
      alt: '',
      title: 'resources',
    };

    this.list.push(home);
    this.list.push(account);
    this.list.push(climate);
    this.list.push(resources);

    return this.list;
  }
}
